if($(".sr-feature-content").length)
{
  var feature_title='<div class="title">Key Features:</div>';
  if($(".page-content").width()>750)
  {
    $(".pc-feature").find(".sr-feature").html(feature_title+$(".sr-feature-content").find(".sr-feature").html());
  }
  else{
    $(".wap-feature").find(".sr-feature").html(feature_title+$(".sr-feature-content").find(".sr-feature").html());
  }
}

var lens_reg=/lens/i;
if(lens_reg.test(location.href))
{
  $(".ship-desc").prepend('<p class="sr-shipping_policy">Extended 6 Months Warranty for Lenses from SIRUI® Official Store.</p>');
  if($("#Sku-7944980398306").length)
  {
    $(".ship-desc p").eq(1).text("Dispatch within 2 days.");
    $(".product-single__meta").addClass("snone");
  }
  //X/L Mount starts shipping on March 18th
}